import { render } from "./TitulacioView.vue?vue&type=template&id=09e8f83c&scoped=true"
import script from "./TitulacioView.vue?vue&type=script&lang=js"
export * from "./TitulacioView.vue?vue&type=script&lang=js"

import "./TitulacioView.vue?vue&type=style&index=0&id=09e8f83c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e8f83c"]])

export default __exports__